import "reflect-metadata";
import "core-js/es6";
import "zone.js/dist/zone";
import "./styles.less";
import { GlobalLibsRegister } from "./app/GlobalLibsRegister";
GlobalLibsRegister.register();

import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/AppModule";

if (process.env.NODE_ENV === "production") {
    enableProdMode();
}

import { AppSettings } from "@nordpoolgroup/nps-angular-2-common";
import { ContractManagementAppSettings } from "./app/ContractManagementAppSettings";
$.get("app.json")
    .then(settings => getSettingsSuccess(settings))
    .fail((error: string) => console.error(error));

function getSettingsSuccess(settings: NPS.Common.IAppSettings) {
    AppSettings.systemConfiguration = settings.systemConfiguration;
    ContractManagementAppSettings.systemConfiguration = settings.systemConfiguration;

    platformBrowserDynamic().bootstrapModule(AppModule);
}



// WEBPACK FOOTER //
// ./src/main.ts